import React, { memo } from 'react';

import { TableContainer, BaseTableProps /* BaseGenericTableProps */ } from '../../components';

type StatesTableProps = {} & BaseTableProps /* & BaseGenericTableProps<AccommodationModel> */;

const StatesTable: React.FunctionComponent<StatesTableProps> = memo(props => {
    console.debug('StatesTable');

    return <TableContainer {...props} columns={props.columns} dataSourcePath="" />;
});

export default StatesTable;
